import { createSlice } from "@reduxjs/toolkit";
import { refreshAxiosInstance } from "../utils/AxiosInstance";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    accessToken: null,
    refreshToken: null,
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem(
        "accessToken",
        JSON.stringify(action.payload.accessToken)
      );
      refreshAxiosInstance(action.payload.accessToken);
    },
    logoutSuccess: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      localStorage.removeItem("user");
      localStorage.removeItem("accessToken");
      refreshAxiosInstance(null);
    },
    updateTokens: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      localStorage.removeItem("accessToken");
      localStorage.setItem(
        "accessToken",
        JSON.stringify(action.payload.accessToken)
      );
      refreshAxiosInstance(action.payload.accessToken);
    },
  },
});

export const { loginSuccess, logoutSuccess, updateTokens } = authSlice.actions;
export default authSlice.reducer;
